import React from 'react';

class Reports extends React.Component {
    render(){
        return(
            <section className="report">
                <div className="container"><h2 className="report__title">Отчётность</h2>
                    <div className="report__block"><p className="report__text"><span className="report__bold">Оперативная отчётность</span> позволяет
                        наблюдать за работой контакт-центра в режиме реального времени, отслеживая загрузку операторов,
                        состояния каналов связи, статистику баз контактов и другие параметры.<span
                            className="report__small"><span className="report__small-red">*</span> — Основной формат выгрузки отчетов - Microsoft Excel</span>
                    </p>
                        <div className="report__text"><span className="report__bold">Историческая
                            отчётность</span> подразумевает хранение и обработку историй всех вызовов для каждого проекта
                            или для всей системы в целом. Допускается построение произвольных отчётов по проектам и
                            операторам.
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Reports;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/Reports.js